import { RequestOptions } from '../interfaces/request-options';
import { UseRequestOptions } from '../interfaces/use-request-options';
import { resolveApiBaseUrl } from '../utils/api-base-url';
import { request } from '../utils/request';

export const useRequest = (options?: UseRequestOptions) => {
  return <T>(requestOptions: Partial<RequestOptions>) => {
    // Determine base URL: prefer explicit option, else map by current origin.
    const base: string | null = (() => {
      if (typeof window === 'undefined') return null;
      if (options?.base !== undefined) return options.base;
      return resolveApiBaseUrl();
    })();

    return request<T>({
      base,
      // Default to authenticated requests; allow explicit override per call.
      authenticate: options?.authenticate ?? true,
      ...requestOptions,
    });
  };
};
